import React from "react";
import carousel from "../../assets/carousel.jpg";
import {
  HiPlus,
  HiChatBubbleOvalLeft,
  HiHeart,
  HiMiniArrowPathRoundedSquare,
} from "react-icons/hi2";

interface TrainingDiaryCardProps {
  className?: string;
}
const PublicFeedCard: React.FC<TrainingDiaryCardProps> = ({
  className = "",
}) => {
  return (
    <div className="carousel flex overflow-x-auto space-x-4">
      <div className="carousel-item snap-center w-full flex-shrink-0">
        <div
          className={`bg-base-100 rounded-lg shadow-sm border border-base-200 p-6 mb-4 max-w-3xl w-full mx-auto relative ${className}`}
        >
          <div className="relative flex items-center space-x-3 rounded-lg bg-base-100 mb-2">
            <div className="shrink-0 ">
              <img alt="" src={carousel} className="size-14 rounded-full" />
            </div>
            <div className="min-w-0 flex-1">
              <button type="button" className="focus:outline-hidden text-left w-full">
                <span aria-hidden="true" className="absolute inset-0" />
                <p className="text-sm font-medium text-base-content">Tori West</p>
                <div className="flex items-center">
                  <p className="truncate text-xs text-base-content/60">Athlete</p>
                  <div className="ml-1 badge badge-soft rounded-md text-xs bg-base-200 px-1">
                    Private
                  </div>
                </div>
                <p className="text-xs mb-2">15th July 2025</p>
              </button>
            </div>
          </div>

          <p className="mb-2 ">
            This is where public posts will go!! People can swipe right to view
            peoples carousels.
          </p>
          <div id="training" className="carousel rounded-md w-full">
            {/* Example Image */}
            <div id="media" className="carousel-item w-full">
              <img
                src={carousel}
                className="w-full"
                alt="Tailwind CSS Carousel component"
              />
            </div>
            {/* Log 1 */}
            <div className="carousel-item w-full">
              <div className="bg-base-200 w-full p-6">
                <p>A training Log</p>
              </div>
            </div>

            {/* Log 2 */}
            <div className="carousel-item w-full">
              <div className="bg-base-200 w-full p-6">
                <p>An example log number 2</p>
              </div>
            </div>
          </div>

          <div className="flex space-x-3 mt-3">
            {/* Likes */}
            <div className="flex items-center gap-1">
              <button className="p-1 text-base-content/80 hover:text-pink-600 hover:bg-pink-500/10 rounded transition-colors">
                <HiHeart className="w-5 h-5" />
              </button>
              <span className="text-xs text-base-content/80 font-outfit">0</span>
            </div>

            {/* Comments */}
            <div className="flex items-center gap-1">
              <button className="p-1 text-base-content/80 hover:text-primary hover:bg-blue-500/10 rounded transition-colors">
                <HiChatBubbleOvalLeft className="w-5 h-5" />
              </button>
              <span className="text-xs text-base-content/80 font-outfit">0</span>
            </div>

            {/* Share */}
            <div className="flex items-center gap-1">
              <button className="p-1 text-base-content/80 hover:text-primary hover:bg-blue-500/10 rounded transition-colors">
                <HiMiniArrowPathRoundedSquare className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicFeedCard;
